import * as React from "react";
import { graphql } from "gatsby";
import Layout from "../components/layout";
import SeoHelmet from "../components/seo-helmet";
import Sidebar from "../components/sidebar";
import Feed from "../components/feed";
import Page from "../components/page";

const TagTemplate = ({ data, pageContext }) => {
  const { nodes } = data.allMarkdownRemark;

  const { tag } = pageContext;

  const pageTitle = `All Posts tagged as "${tag}"`;

  return (
    <Layout>
      <SeoHelmet title={pageTitle} />
      <Sidebar />
      <Page>
        <Feed nodes={nodes} />
      </Page>
    </Layout>
  );
};

export default TagTemplate;

export const pageQuery = graphql`
  query TagPage($tag: String) {
    allMarkdownRemark(
      filter: { frontmatter: { tags: { in: [$tag] } } }
      sort: { order: DESC, fields: [frontmatter___date] }
    ) {
      nodes {
        fields {
          slug
          categorySlug
        }
        frontmatter {
          title
          date(formatString: "MMMM DD, YYYY")
          category
          description
        }
      }
    }
  }
`;
